import React from 'react';
import {Image, StyleSheet} from 'react-native';

const LoadingImg = () => {
  return (
    <Image
      source={require('../images/brand/loading.gif')}
      style={styles.loader}
      resizeMode="contain"
    />
  );
};

export default LoadingImg;

const styles = StyleSheet.create({
  loader: {
    flex: 1,
    maxWidth: 500,
    aspectRatio: 1,
    alignSelf: 'center',
    left: undefined,
    right: undefined,
  },
});
